import { render } from "./trend-charts.vue?vue&type=template&id=21bb78b7"
import script from "./trend-charts.vue?vue&type=script&lang=ts"
export * from "./trend-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script